(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/new-game.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/new-game.js');
'use strict';

const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  fetchProducts
} = svs.arena.store.teams.actions;
const {
  ErrorMessage
} = svs.arena.shared.components;
const {
  NewGameItem
} = svs.arena.pages.teams.components;
const {
  hooks
} = svs.arena.shared;
const NewGame = _ref => {
  let {
    teamId
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [isTeamMissingError, setIsTeamMissingError] = React.useState(false);
  const [isExpandedTrack, setIsExpandedTrack] = React.useState(true);
  const {
    data,
    error
  } = hooks.useProducts();
  const isError = error || isTeamMissingError;
  React.useEffect(() => {
    if (!teamId) {
      setIsTeamMissingError(true);
    } else {
      setIsTeamMissingError(false);
    }
  }, [teamId]);
  const trackClick = () => {
    setIsExpandedTrack(current => !current);
    const track = {
      category: 'spela-tillsammans',
      action: 'play_new_game',
      opt_label: isExpandedTrack ? 'card_click' : 'card_closed'
    };
    svs.components.analytics.trackEvent(track);
  };
  return React.createElement("div", null, React.createElement(Accordion, {
    className: "margin-top-1"
  }, React.createElement(AccordionItem, {
    onChange: trackClick
  }, React.createElement(AccordionSummary, null, "L\xE4gg nytt spel"), React.createElement(AccordionDetails, {
    className: "padding-override-0"
  }, isError && React.createElement(ErrorMessage, {
    actions: [{
      handleClick: () => dispatch(fetchProducts()),
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign",
    text: "N\xE5gonting gick fel n\xE4r dina produkter skulle visas upp. F\xF6rs\xF6k igen om en stund."
  }), !isError && (data === null || data === void 0 ? void 0 : data.map(product => React.createElement(React.Fragment, {
    key: product.productName + (product.productId && !product.productId.isArray ? product.productId : 'noId')
  }, React.createElement(NewGameItem, {
    product: product,
    teamId: teamId
  }))))))));
};
svs.arena.pages.teams.components.NewGame = NewGame;

 })(window);